import React, { useEffect, useState } from "react";
import DOCOnlineWelcomePage from "./DOCOnlineWelcomePage/DOCOnlineWelcomePage";




import DOCOnlineUploadDocuments from "./DOCOnlineUploadDocuments";
import ProgressBar from "../../components/DocProgressBar/ProgressBar";
import { useDOCOnlineContext } from "./DOCOnlineContext";
import { useTranslation } from "react-i18next";
import DOCOnlineSpinner from "../../containers/FullPageSpinner/FullPageSpinner";
import DOCOnlineSuccessPage from "./DOCOnlineSuccessPage";
import DOCOnlineTechSkillsList from "../Interview/EditDocOnline/DOCOnlineTechSkills/DOCOnlineTechSkillsList";
import DOCOnlineWorkExperience from "../Interview/EditDocOnline/DOCOnlineWorkExperience/DOCOnlineWorkExperience";
import DOCOnlineEducationAndLanguage from "../Interview/EditDocOnline/DOCOnlineEducationAndLanguage/DOCOnlineEducationAndLanguage";
import DOCOnlinePersonalInformation from "../Interview/EditDocOnline/DOCOnlinePersonalInformation";
import { AnonymusDocOnlineService } from "../../services/AnonymusDocOnlineService";

const DOCOnlineBody = ({ token, companyId, isLoading }) => {
  const { t } = useTranslation();
  const {
    GetDocOnlineByToken,
    setDocOnline,
    docOnline,
    tokenInvalid,
    currentStep,
    checkEducationErrors,
    checkPersonalInfoErrors,
    checkTechSkillsErrors,
    checkWorkExpErrors,
    setCurrentStep,
    SubmitDoc,
    errors,
    setErrors,
    autoCompleteCourseData,
    autoCompleteSchoolData,
    submitDocOnlineIsDisabled,
    LanguageLevels,
    Languages, jobRoles,
    maritalStatus,
    zones,
    comboBoxList,
    skillLevels,
    yearsExperience,
    techSkills
  
  } = useDOCOnlineContext();

  const [_isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (token) {
      setToken(token);
    }
    GetDocOnlineByToken(token).finally(() => {
      setIsLoading(false);
    });
  }, []);

  function setToken(value) {
    setDocOnline({
      ...docOnline,
      token: value
    });
  }

  if (isLoading) {
    return null;
  }

  if (tokenInvalid === false || _isLoading === false) {
    return (
      <>
        {currentStep <= 6 && (
          <ProgressBar
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            showWelcomeCircle={true}
            showUploadDocument={true}
            checkPersonalInfoErrors={checkPersonalInfoErrors}
            checkEducationErrors={checkEducationErrors}
            checkWorkExpErrors={checkWorkExpErrors}
            checkTechSkillsErrors={checkTechSkillsErrors}
          />
        )}
        <form className="doc-online-container">
          <section className="step">
            {currentStep === 1 && <DOCOnlineWelcomePage />}
            {currentStep === 2 && <DOCOnlinePersonalInformation 
            docOnline={docOnline}
            setDocOnline={setDocOnline}
            errors={errors}
            setErrors={setErrors}
            jobRoles={jobRoles}
            maritalStatus={maritalStatus}
            zones={zones}
            
            
            
            />}
            {currentStep === 3 && <DOCOnlineEducationAndLanguage 
            
            docOnline={docOnline}
            autoCompleteCourseData={autoCompleteCourseData}
            autoCompleteSchoolData={autoCompleteSchoolData}
            setDocOnline={setDocOnline}
            errors={errors}
            languageLevels={LanguageLevels}
            languages={Languages}
            
            
            />}
            {currentStep === 4 && (
              <DOCOnlineWorkExperience
                docOnline={docOnline}
                setDocOnline={setDocOnline}
               errors={errors}
              />
            )}
            {currentStep === 5 && (
              <DOCOnlineTechSkillsList
                docOnline={docOnline}
                setDocOnline={setDocOnline}
                errors={errors}
                skillLevels={skillLevels}
                yearsExperience={yearsExperience}
                techSkills={techSkills}
                techSkillsHasLoaded={true}
                comboBoxList={comboBoxList}
                DOCOnlineService={AnonymusDocOnlineService}
               
              />
            )}
            {currentStep === 6 && (
              <DOCOnlineUploadDocuments
                docOnline={docOnline}
                setDocOnline={setDocOnline}
                companyId={companyId}
              />
            )}
            <DOCOnlineSuccessPage />
            <div className="text-end">
              {currentStep > 2 && currentStep < 7 && (
                <button
                  className="app-button btn-second btn-md"
                  type="button"
                  onClick={() => {
                    setCurrentStep(currentStep - 1);
                  }}
                >
                  {t("Back")}
                </button>
              )}
              {currentStep < 6 && currentStep > 1 && (
                <button
                  className="app-button btn-prime btn-md"
                  type="button"
                  onClick={() => {
                    setCurrentStep(currentStep + 1);
                  }}
                >
                  {t("Next")}
                </button>
              )}
              {currentStep === 6 && (
                <button
                  className="app-button btn-prime btn-md upload-footer-doconline"
                  type="button"
                  disabled={submitDocOnlineIsDisabled}
                  onClick={() => {
                    SubmitDoc();
                  }}
                >
                  {t("Submit")}
                </button>
              )}
              {currentStep === 5 && (
                <div className="techskill-footer-doconline">
                </div>
              )}
            </div>
          </section>
        </form>
      </>
    );
  } else {
    return <DOCOnlineSpinner text={t("Please wait while the page loads...")} />;
  }
};

export default DOCOnlineBody;
